export const profileDict = {
    en: {
      "Profile": "Profile",
      "Your Profile": "Your Profile",
      "Email Address": "Email Address",
      "First Name": "First Name",
      "Last Name": "Last Name",
      "City": "City",
      "Country": "Country",
      "Postal Code": "Postal Code",
      "Edit": "Edit",
      "Update Profile": "Update Profile",
      "Email": "Email",
      "Mobile Number": "Mobile Number",
      "Gender": "Gender",
      "Male": "Male",
      "Female": "Female",
      "Other": "Other",
      "Date of Birth": "Date of Birth",
      "PinCode": "PinCode",
      "Address Line 1": "Address Line 1",
      "Address Line 2": "Address Line 2",
      "State": "State",
      "Referral Source": "Referral Source",
      "Select a Referral": "Select a Referral",
      "Submit": "Submit",
      "Reset": "Reset"
    },
    hi: {
      "Profile": "प्रोफ़ाइल",
      "Your Profile": "आपकी प्रोफ़ाइल",
      "Email Address": "ईमेल पता",
      "First Name": "पहला नाम",
      "Last Name": "उपनाम",
      "City": "शहर",
      "Country": "देश",
      "Postal Code": "डाक कोड",
      "Edit": "संपादन करना",
      "Update Profile": "प्रोफ़ाइल अपडेट करें",
      "Email": "ईमेल",
      "Mobile Number": "मोबाइल नंबर",
      "Gender": "लिंग",
      "Male": "पुरुष",
      "Female": "महिला",
      "Other": "अन्य",
      "Date of Birth": "जन्म की तारीख",
      "PinCode": "पिन कोड",
      "Address Line 1": "पता पंक्ति 1",
      "Address Line 2": "पता पंक्ति नं। 2",
      "State": "राज्य",
      "Referral Source": "रेफरल के स्रोत",
      "Select a Referral": "एक रेफरल का चयन करें",
      "Submit": "जमा करना",
      "Reset": "पुन्ह: सेट करे"
    },
    jp: {
      "Profile": "プロフィール",
      "Your Profile": "あなたのプロフィール",
      "Email Address": "メールアドレス",
      "First Name": "名",
      "Last Name": "姓",
      "City": "市区町村",
      "Country": "国",
      "Postal Code": "郵便番号",
      "Edit": "編集",
      "Update Profile": "プロフィール更新",
      "Email": "メールアドレス",
      "Mobile Number": "電話番号",
      "Gender": "性別",
      "Male": "男性",
      "Female": "女性",
      "Other": "その他",
      "Date of Birth": "生年月日",
      "PinCode": "郵便番号",
      "Address Line 1": "住所1",
      "Address Line 2": "住所2",
      "State": "都道府県",
      "Referral Source": "紹介元",
      "Select a Referral": "紹介元を選択",
      "Submit": "送信",
      "Reset": "リセット"
    }
  };

  export const menuDict = {
    en: {
      "Profile": "Profile",
      "Settings": "Settings",
      "Logout": "Logout",
      "Edit": "Edit",
    "Change Password": "Change Password",
    "Notification" : "Notification",
    "No notifications" : "No notifications available"
    },
    hi: {
      "Profile": "प्रोफ़ाइल",
      "Settings": "सेटिंग",
      "Logout": "लॉग आउट",
      "Edit": "संपादित करें",
      "Change Password": "पासवर्ड बदलें",
      "Notification" : "सूचना",
      "No notifications" : "कोई सूचना उपलब्ध नहीं है"
    },
    jp: {
      "Profile": "プロフィール",
      "Settings": "設定",
      "Logout": "ログアウト",
      "Edit": "編集",
    "Change Password": "パスワード変更",
    "Notification" : "通知",
    "No notifications" : "通知はありません"
    }
  };

